// apps/dashboard/src/routes/targets/$targetId/scans/$scanId.tsx
import { ScanReportView } from "@/components/targets/scans/ScanReportView";
import { ScanViewProvider } from "@/components/targets/scans/ScanViewContext";
import { useScanActions } from "@/components/targets/scans/useScanActions";
import { RouteShell } from "@/design-system";
import { useScanStream } from "@/hooks/useScanStream";
import { useScanIssueStatus } from "@/stores/scan-issue-status";
import { useScanTabs } from "@/stores/scan-tabs";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/targets/$targetId/scans/$scanId")({
  component: ScanReportPage,
});

function ScanReportPage() {
  const { targetId, scanId } = Route.useParams();

  const timeline = useScanStream(scanId);
  const { scan, isLive, isPending, error, report } = timeline;

  const { cancel, rerun, rerunDialog, deleteScanAction, deleteDialog } =
    useScanActions(scanId, targetId, report);
  const resetTabs = useScanTabs((s) => s.reset);
  const resetIssueStatus = useScanIssueStatus((s) => s.reset);

  useEffect(() => {
    resetTabs();
    resetIssueStatus();
  }, [scanId, resetTabs, resetIssueStatus]);

  return (
    <ScanViewProvider isPublic={false}>
      {rerunDialog}
      {deleteDialog}
      <RouteShell
        isPending={isPending}
        error={error}
        loadingLabel="Loading scan report…"
      >
        {scan && report ? (
          <ScanReportView
            targetId={targetId}
            scanId={scanId}
            report={report}
            checks={timeline.checks}
            rawEvents={timeline.rawEvents}
            isLive={!!isLive}
            onRerun={rerun.mutate}
            rerunPending={rerun.isPending}
            rerunBlocked={rerun.blocked}
            onCancel={cancel.mutate}
            cancelPending={cancel.isPending}
            onDelete={deleteScanAction.open}
          />
        ) : null}
      </RouteShell>
    </ScanViewProvider>
  );
}
